<template>
  <h1> Light Bulbs Experiment </h1>
  <p> <strong> Objective: </strong> Turn on all the light bulbs, with the minimum amount of moves!</p>
  <p> Moves: <strong> {{ moves }} </strong> </p>
  <div>
    <light-bulb v-for="(status, index) in lights" :key="index" :lightId="index" :lightStatus="status"> </light-bulb>
  </div>
  <p style="color:red" v-if="win"> Won! </p>
  <button @click="reset"> Reset </button>
</template>

<script>
import LightBulb from './components/LightBulb.vue';

export default {
  name: 'App',
  components: {
    LightBulb,
  },
  data() {
    let lights = [];
    let lightsNum = 10;
    for(let i = 0; i < lightsNum; i++){
      lights.push(false);
    }
    return {
      lights: lights,
      moves: 0,
      win: false,
    };
  },
  provide() {
    return {
      toggleSwitch: this.toggleSwitch,
    }
  },
  methods: {
    reset() {
      this.moves = 0;
      this.win = false;
      for(let i = 0; i < this.lights.length; i++){
        this.lights[i] = false;
      }
    },
    checkObjective(){
      let win = true;
      for(let status of this.lights){
        if(!status){
          win = false;
          break;
        }
      }
      this.win = win;
      if(win){
        console.log("Won");
      }
    },
    toggleLight(lightId) {
      this.lights[lightId] = !this.lights[lightId];
    },
    toggleSwitch(lightId) {
      this.moves++;
      let lightsNum = this.lights.length;
      let index;
      this.toggleLight(lightId);
      index = lightId + 1;
      if(index === lightsNum){
        index = 0;
      }
      this.toggleLight(index);
      index = lightId - 1;
      if(index < 0){
        index = lightsNum - 1;
      }
      this.toggleLight(index);
      this.checkObjective();
    },
  },
}
</script>

<style>
/* Importing Fonts */
@import url('https://fonts.googleapis.com/css2?family=Jost&display=swap');
* {
  font-family: 'Jost', sans-serif;
}
body{
  background: #EDEDED;
}
</style>
